import { z } from 'zod';
import { roleCapabilities } from './capabilities.js';
export const actionSchema = z.object({
    action: z.string(),
    title: z.string(),
});
export const notificationOptionsSchema = z.object({
    body: z.string().optional(),
    icon: z.string().optional(),
    image: z.string().optional(),
    link: z.string().optional(),
    tag: z.string().optional(),
    badge: z.number().optional(),
    data: z.record(z.string(), z.unknown()).optional(),
    actions: actionSchema.array().optional(),
});
export const pushNotificationSchema = z.object({
    title: z.string().optional(),
    options: notificationOptionsSchema.optional(),
    invalidateQueries: z.array(z.array(z.string())).optional(),
});
export const notificationStatsSchema = z.object({
    unread: z.number(),
    unseen: z.number(),
});
/** Session SSE / presence platform. */
export const sessionPlatformSchema = z.enum(['web', 'ios', 'android']);
/** Invalidate-light envelope mirrored from web push. */
export const sessionEventSchema = z.object({
    type: z.literal('invalidate'),
    notification: pushNotificationSchema.optional(),
    notificationStats: notificationStatsSchema.optional(),
});
export const notificationTypeSchema = z.object({
    type: z.string(),
    requiredCapabilities: z.enum(roleCapabilities).array().optional(),
    defaultSettings: z.object({
        create: z.boolean(),
        push: z.boolean(),
        email: z.boolean(),
    }).optional(),
});
export const notificationDefaults = {
    create: true,
    push: true,
    email: false,
};
export const notificationAll = {
    create: true,
    push: true,
    email: true,
};
